<script>
import Card from '@vvg/forum/vue/components/card.vue'
import { Link } from '@inertiajs/vue3'
import Permissions from '@vvg/forum/js/mixins/permissions.js'
import Ajax from '@vvg/forum/js/mixins/ajax.js'
import Scroll from '@vvg/forum/js/mixins/scroll.js'
import FormModal from '@vvg/forum/vue/forum/modal.vue'

export default {
	components: { Card, Link, FormModal },
	mixins: [Ajax, Permissions, Scroll],
	data() {
		return {
			forums: [],
		};
	},
	computed: {
		scrollKey() {
			return 'overview';
		},
	},
	mounted() {
		this.getForums();
	},
	methods: {
		getForums() {
			this.Ajax(this.$page.props.forum_url +  '/retrieve_forums/', 'GET').then(response => {
				this.forums = response.data;
				this.$nextTick(() => this.applyScroll());
			});
		},
		applyScroll() {
			const target = this.readForumScroll(this.scrollKey);
			if (target && target.targetId && this.scrollToId(target.targetId)) {
				this.clearForumScroll(this.scrollKey);
				return;
			}
			this.scrollToForum();
		},
		openForum(forum) {
			this.rememberForumScroll(this.scrollKey, { targetId: 'forum-' + forum.id });
		},
		editForum(forum) {
			this.$refs.formModal.open(forum);
		},
		deleteForum(index, id) {
			if (!confirm('Weet u zeker dat u deze rubriek wilt verwijderen?')) return;
			this.Ajax(this.$page.props.forum_url + 'delete_forum/', 'POST', { forum_id: id }).then(response => {
				this.showToast(response.message, 'success');
				this.forums.splice(index, 1);
			});
		},
	},
};
</script>

<template>
  <div class="container-xl py-4">

    <div class="forum-header d-flex justify-content-between align-items-end mb-4">
      <div>
        <h1 class="mb-0">Forum</h1>
        <p class="text-muted small mb-0">{{ forums.length }} rubrieken</p>
      </div>
      <button
          v-if="hasRole('Administrator')"
          @click="$refs.formModal.open()"
          class="btn btn-dark btn-sm d-flex align-items-center gap-2"
      >
        <i class="fa fa-plus"></i> Aanmaken
      </button>
    </div>

    <div class="forum-list">
      <Link
          v-for="(forum, index) in forums"
          :key="forum.id"
          :id="'forum-' + forum.id"
          :href="$page.props.forum_url + forum.id + '/onderwerpen/'"
          class="forum-row"
          @click="openForum(forum)"
      >
        <div class="forum-row__left">
          <div class="forum-thumb">
            <img
                v-if="forum.overview_image"
                :src="forum.overview_image.file_location"
                :alt="forum.title"
            />
            <i v-else class="fa fa-comments text-muted"></i>
          </div>
          <div class="forum-info">
            <span class="forum-title">{{ forum.title }}</span>
            <div class="forum-meta">
              <span><i class="fa fa-comment"></i> {{ forum.topics_count ?? 0 }} onderwerpen</span>
              <span v-if="forum.updated_at">
                <i class="fa fa-clock-o"></i> {{ forum.updated_at }}
              </span>
            </div>
          </div>
        </div>

        <div v-if="hasRole('Administrator')" class="forum-row__actions" @click.stop>
          <button @click.prevent="editForum(forum)" class="act-btn" title="Bewerken">
            <i class="fa fa-edit"></i>
          </button>
          <button @click.prevent="deleteForum(index, forum.id)" class="act-btn act-btn--danger" title="Verwijderen">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </Link>

      <div v-if="forums.length === 0" class="forum-empty">
        Geen rubrieken gevonden
      </div>
    </div>

  </div>

  <FormModal @save:forum="getForums()" ref="formModal" />
</template>

<style scoped>
.forum-grid {
	display: grid;
	grid-template-columns: 1fr 100px;
	align-items: center;
	gap: 0 16px;
}

.forum-row:hover {
	background: #f8f9fa;
}

.forum-image {
	width: 88px;
	aspect-ratio: 1;
	flex-shrink: 0;
}

</style>